<template>
  <Loading :loading="loading" text="报表数据计算中..."/>
  <vxe-toolbar class-name="px-8px">
    <template #buttons>
      <DatePicker ref="dateComp" v-if="dimension==='QUARTER'" :option = "quarterRange" v-model="voucherDate" type="quarter" :clearable="false"/>
			<account-date-choose v-else v-model="voucherDate"/>
    </template>
    <template #tools>
      <vxe-button @click="loadData()" icon="fa fa-refresh" content="刷新"/>
      <vxe-button :loading="dloading" @click="exportData" icon="fa fa-download" content="导出"/>
    </template>
  </vxe-toolbar>
  <div ref="reportContent" style="padding: 8px;overflow: auto">
    <!-- xf -->
    <table class="cus-table" style="min-width: 100%" v-if="User.accountSets.accountStandard == 'NONGOVERNMENTAL'">
      <thead class="header">
          <tr>
              <td rowspan="2">项目</td>
              <td rowspan="2">行次</td>
              <td colspan="3">本月数</td>
              <td colspan="3">本年数</td>
          </tr>
          <tr>
              <!-- <td></td>
              <td></td> -->
              <td>非限定性</td>
              <td>限定性</td>
              <td>合计</td>
              <td>非限定性</td>
              <td>限定性</td>
              <td>合计</td>
          </tr>
      </thead>
      <tbody>
          <tr>
              <td style="font-weight: 900;">一、收入</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其中：捐赠收入</td>
              <td>1</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('捐赠收入非限定性','本期金额')) * 100 + Number(seachData('捐赠收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('捐赠收入非限定性','本年累计')) * 100 + Number(seachData('捐赠收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;会费收入</td>
              <td>2</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('会费收入非限定性','本期金额')) * 100 + Number(seachData('会费收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('会费收入非限定性','本年累计')) * 100 + Number(seachData('会费收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;提供服务收入</td>
              <td>3</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('提供服务收入非限定性','本期金额')) * 100 + Number(seachData('提供服务收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('提供服务收入非限定性','本年累计')) * 100 + Number(seachData('提供服务收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;商品销售收入</td>
              <td>4</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('商品销售收入非限定性','本期金额')) * 100 + Number(seachData('商品销售收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('商品销售收入非限定性','本年累计')) * 100 + Number(seachData('商品销售收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;政府补助收入</td>
              <td>5</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('政府补助收入非限定性','本期金额')) * 100 + Number(seachData('政府补助收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('政府补助收入非限定性','本年累计')) * 100 + Number(seachData('政府补助收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;投资收益</td>
              <td>6</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('投资收益非限定性','本期金额')) * 100 + Number(seachData('投资收益限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('投资收益非限定性','本年累计')) * 100 + Number(seachData('投资收益限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其他收入</td>
              <td>9</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他收入非限定性','本期金额')) * 100 + Number(seachData('其他收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他收入非限定性','本年累计')) * 100 + Number(seachData('其他收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;收入合计</td>
              <td>11</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('收入合计非限定性','本期金额')) * 100 + Number(seachData('收入合计限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('收入合计非限定性','本年累计')) * 100 + Number(seachData('收入合计限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td style="font-weight: 900;">二、费用</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;（一）业务活动成本</td>
              <td>12</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;（二）管理费用</td>
              <td>21</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;（三）筹资费用</td>
              <td>24</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;（四）其他费用</td>
              <td>28</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;费用合计</td>
              <td>35</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td style="font-weight: 900;">三、限定性净资产转为非限定性净资产</td>
              <td>40</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本月非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本月限定性)}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本年非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本年限定性)}) }}</td>
              <td></td>
          </tr>
          <tr>
              <td style="font-weight: 900;">四、净资产变动额(减少额，以“ - ”号填列)</td>
              <td>45</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change1}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change2}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(changeData.change1) * 100 + Number(changeData.change2) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change3}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change4}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(changeData.change3) * 100 + Number(changeData.change4) * 100) / 100}) }}</td>
          </tr>
      </tbody>
  </table>

<!-- xf -->
  <table class="cus-table" style="min-width: 100%" v-else>
      <thead class="header">
          <tr>
              <td rowspan="2">项目</td>
              <td rowspan="2">行次</td>
              <td colspan="3">本月数</td>
              <td colspan="3">本年数</td>
          </tr>
          <tr>
              <!-- <td></td>
              <td></td> -->
              <td>非限定性</td>
              <td>限定性</td>
              <td>合计</td>
              <td>非限定性</td>
              <td>限定性</td>
              <td>合计</td>
          </tr>
      </thead>
      <tbody>
          <tr>
              <td style="font-weight: 900;">一、收入</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其中：捐赠收入</td>
              <td>1</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('捐赠收入非限定性','本期金额')) * 100 + Number(seachData('捐赠收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('捐赠收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('捐赠收入非限定性','本年累计')) * 100 + Number(seachData('捐赠收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;会费收入</td>
              <td>2</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('会费收入非限定性','本期金额')) * 100 + Number(seachData('会费收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('会费收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('会费收入非限定性','本年累计')) * 100 + Number(seachData('会费收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;提供服务收入</td>
              <td>3</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('提供服务收入非限定性','本期金额')) * 100 + Number(seachData('提供服务收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('提供服务收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('提供服务收入非限定性','本年累计')) * 100 + Number(seachData('提供服务收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;政府补助收入</td>
              <td>5</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('政府补助收入非限定性','本期金额')) * 100 + Number(seachData('政府补助收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('政府补助收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('政府补助收入非限定性','本年累计')) * 100 + Number(seachData('政府补助收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;商品销售收入</td>
              <td>4</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('商品销售收入非限定性','本期金额')) * 100 + Number(seachData('商品销售收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('商品销售收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('商品销售收入非限定性','本年累计')) * 100 + Number(seachData('商品销售收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;总部拨款收入</td>
              <td>5</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('总部拨款收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('总部拨款收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('总部拨款收入非限定性','本期金额')) * 100 + Number(seachData('总部拨款收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('总部拨款收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('总部拨款收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('总部拨款收入非限定性','本年累计')) * 100 + Number(seachData('总部拨款收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;投资收益</td>
              <td>6</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('投资收益非限定性','本期金额')) * 100 + Number(seachData('投资收益限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('投资收益限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('投资收益非限定性','本年累计')) * 100 + Number(seachData('投资收益限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其他收入</td>
              <td>9</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他收入非限定性','本期金额')) * 100 + Number(seachData('其他收入限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他收入限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他收入非限定性','本年累计')) * 100 + Number(seachData('其他收入限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;收入合计</td>
              <td>11</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('收入合计非限定性','本期金额')) * 100 + Number(seachData('收入合计限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('收入合计限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('收入合计非限定性','本年累计')) * 100 + Number(seachData('收入合计限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td style="font-weight: 900;">二、费用</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;业务活动成本</td>
              <td>12</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('业务活动成本非限定性','本期金额')) * 100 + Number(seachData('业务活动成本限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('业务活动成本限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('业务活动成本非限定性','本年累计')) * 100 + Number(seachData('业务活动成本限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其中：</td>
              <td>12</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;税金及附加</td>
              <td>21</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('税金及附加非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('税金及附加限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('税金及附加非限定性','本期金额')) * 100 + Number(seachData('税金及附加限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('税金及附加非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('税金及附加限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('税金及附加非限定性','本年累计')) * 100 + Number(seachData('税金及附加限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;管理费用</td>
              <td>21</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('管理费用非限定性','本期金额')) * 100 + Number(seachData('管理费用限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('管理费用限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('管理费用非限定性','本年累计')) * 100 + Number(seachData('管理费用限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;筹资费用</td>
              <td>24</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('筹资费用非限定性','本期金额')) * 100 + Number(seachData('筹资费用限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('筹资费用限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('筹资费用非限定性','本年累计')) * 100 + Number(seachData('筹资费用限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;资产减值损失</td>
              <td>24</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('资产减值损失非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('资产减值损失限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('资产减值损失非限定性','本期金额')) * 100 + Number(seachData('资产减值损失限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('资产减值损失非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('资产减值损失限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('资产减值损失非限定性','本年累计')) * 100 + Number(seachData('资产减值损失限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
           <tr>
              <td>&nbsp;&nbsp;&nbsp;所得税费用</td>
              <td>24</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('所得税费用','本期金额'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('所得税费用','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('所得税费用','本年累计'))}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('所得税费用','本年累计'))}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;其他费用</td>
              <td>28</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他费用非限定性','本期金额')) * 100 + Number(seachData('其他费用限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('其他费用限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('其他费用非限定性','本年累计')) * 100 + Number(seachData('其他费用限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td>&nbsp;&nbsp;&nbsp;费用合计</td>
              <td>35</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('费用合计非限定性','本期金额')) * 100 + Number(seachData('费用合计限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('费用合计限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('费用合计非限定性','本年累计')) * 100 + Number(seachData('费用合计限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td style="font-weight: 900;">三、限定性净资产转为非限定性净资产</td>
              <td>40</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本月非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本月限定性)}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本年非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(restrictionReleaseData.本年限定性)}) }}</td>
              <td></td>
          </tr>
          <tr>
              <td style="font-weight: 900;">四、非限定性净资产转为限定性净资产</td>
              <td>40</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(releaseRestrictionData.本月非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(releaseRestrictionData.本月限定性)}) }}</td>
              <td></td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(releaseRestrictionData.本年非限定性)}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(releaseRestrictionData.本年限定性)}) }}</td>
              <td></td>
          </tr>
          <tr>
              <td style="font-weight: 900;">五、以前年度净资产调整</td>
              <td>40</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('五、以前年度净资产调整非限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('五、以前年度净资产调整限定性','本期金额'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('五、以前年度净资产调整非限定性','本期金额')) * 100 + Number(seachData('五、以前年度净资产调整限定性','本期金额')) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('五、以前年度净资产调整非限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:Number(seachData('五、以前年度净资产调整限定性','本年累计'))}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(seachData('五、以前年度净资产调整非限定性','本年累计')) * 100 + Number(seachData('五、以前年度净资产调整限定性','本年累计')) * 100) / 100}) }}</td>
          </tr>
          <tr>
              <td style="font-weight: 900;">六、净资产变动额（若为净资产减少额，以“-”号填列）</td>
              <td>45</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change1}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change2}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(changeData.change1) * 100 + Number(changeData.change2) * 100) / 100}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change3}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:changeData.change4}) }}</td>
              <td>{{ VXETable.formats.store.toMoney({cellValue:(Number(changeData.change3) * 100 + Number(changeData.change4) * 100) / 100}) }}</td>
          </tr>
      </tbody>
  </table>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "fyllrReportView"
}
</script>

<script setup>

import ReportApi from "@/api/report";
import {ref, toRefs, watch} from "vue";
import {toArrayTree} from "xe-utils";
import ReportRow from "@/views/report/view/ReportRow";
import {useStore} from "vuex";
import manba from "manba";
import setting from "@/api/setting";
import jQuery from "jquery";
import Report from "@/api/report";
import {downloadBlob} from "download.js";
import {VXETable} from "vxe-table";

const store = useStore();
const {currentAccountSets} = store.state
const User = store.state.User;

const props = defineProps(['report', 'dimension']);

const {report, dimension} = toRefs(props);
const reportContent = ref(null);
const loading = ref(false);
const dloading = ref(false);
const voucherDate = ref(currentAccountSets.currentAccountDate)
const accountSetsName = ref(currentAccountSets.companyName)

const reportData = ref({})

const restrictionReleaseData = ref({})
const releaseRestrictionData = ref({}) //xf
const changeData = ref({})

const items = ref([])
const quarterRange = ref({});

if (dimension.value === 'QUARTER') {
	quarterRange.value = {"start":manba(User.checkoutList[User.checkoutList.length - 1].checkDate).startOf(manba.QUARTER).format(),"end":manba(User.checkoutList[0].checkDate).endOf(manba.QUARTER).format()}
	voucherDate.value = manba(currentAccountSets.currentAccountDate).startOf(manba.QUARTER).format()
}

const seachData = (title,type) =>{
  if(Object.keys(reportData.value).length === 0){return ''}
  let result = ''; // 初始化结果变量
  Object.keys(reportData.value).forEach(key => {
      // console.log(reportData.value[key]);
      if(reportData.value[key].title === title){
        switch (type) {
          case '本年累计':
           result = reportData.value[key].values.本年累计.toFixed(2);
          break;
          case '本期金额':
           result = reportData.value[key].values.本期金额.toFixed(2);
          break;
        }
        
      }
  });
  return result;
}

//xf
const loadData = () => {
  if(User.accountSets.accountStandard == 'NONGOVERNMENTAL2026'){
    loading.value = true;
    // 1. 先获取主报表数据
    ReportApi.view(report.value.templateKey, {
      voucherDate: voucherDate.value,
      dimension: dimension.value
    }).then(({ data }) => {
      reportData.value = Object.assign(reportData.value, data);
      // 2. 并行请求两个转换接口 (非盈利特有)
      // 使用 Promise.all 同时发起两个请求，等待它们都完成
      const p1 = ReportApi.restrictionRelease({
        voucherDate: voucherDate.value,
        dimension: dimension.value
      });
      const p2 = ReportApi.releaseRestriction({
        voucherDate: voucherDate.value,
        dimension: dimension.value
      });
      return Promise.all([p1, p2]);
    }).then(([resRelease, resRestrict]) => {
      // 3. 两个接口都成功后，在这里处理数据
      // resRelease 是 restrictionRelease 的响应 (限定转非限定)
      // resRestrict 是 releaseRestriction 的响应 (非限定转限定)
      const dataRelease = resRelease.data; 
      const dataRestrict = resRestrict.data;
      // 保存数据到响应式变量 (如果需要分别展示)
      restrictionReleaseData.value = dataRelease;
      // 假设你也有一个 variable 存另一个，如果没有可以注释掉或新建
      releaseRestrictionData.value = dataRestrict; 

      // 调试日志
      console.log("限定转非限定:", dataRelease);
      console.log("非限定转限定:", dataRestrict);
      console.log("原始报表本期非限定:", seachData("资产变动额非限定性", "本期金额"));
      console.log("原始报表本期限定:", seachData("资产变动额限定性", "本期金额"));

      // 4. 执行计算逻辑
      // 逻辑：原始值 + (限定转非限定的影响) + (非限定转限定的影响)
      // 注意：后端返回的字符串可能包含负号，Number() 会自动处理
      
      let baseNonLimitCurrent = Number(seachData("资产变动额非限定性", "本期金额") || 0);
      let baseLimitCurrent = Number(seachData("资产变动额限定性", "本期金额") || 0);
      let baseNonLimitYear = Number(seachData("资产变动额非限定性", "本年累计") || 0);
      let baseLimitYear = Number(seachData("资产变动额限定性", "本年累计") || 0);

      // 本期计算
      let a = baseNonLimitCurrent 
              + Number(dataRelease.本月非限定性 || 0) 
              + Number(dataRestrict.本月非限定性 || 0);
              
      let b = baseLimitCurrent 
              + Number(dataRelease.本月限定性 || 0) 
              + Number(dataRestrict.本月限定性 || 0);

      // 本年累计计算
      let c = baseNonLimitYear 
              + Number(dataRelease.本年非限定性 || 0) 
              + Number(dataRestrict.本年非限定性 || 0);
              
      let d = baseLimitYear 
              + Number(dataRelease.本年限定性 || 0) 
              + Number(dataRestrict.本年限定性 || 0);

      let f = {
        "change1": a, // 非限定本期
        "change2": b, // 限定本期
        "change3": c, // 非限定本年
        "change4": d  // 限定本年
      };
      
      changeData.value = f;
      console.log("最终计算结果:", changeData.value);

    }).catch((error) => {
      console.error("加载数据或计算失败:", error);
      // 这里可以添加错误提示，例如 ElMessage.error('数据加载失败');
    }).finally(() => {
      // 无论成功还是失败，最后关闭 loading
      loading.value = false;
    });
  }else{
    loading.value = true;
    ReportApi.view(report.value.templateKey, {
      voucherDate:voucherDate.value,
      dimension: dimension.value
    }).then(({data}) => {
      reportData.value = Object.assign(reportData.value, data);
      //非盈利查限定转非限定金额
      ReportApi.restrictionRelease({
        voucherDate: voucherDate.value,
        dimension: dimension.value
      }).then(({data}) => {
        restrictionReleaseData.value = data;
        console.log(seachData("资产变动额限定性","本期金额"),
        seachData("资产变动额非限定性","本期金额"),
        seachData("资产变动额限定性","本年累计"),
        seachData("资产变动额非限定性","本年累计"))
        let a = Number(seachData("资产变动额非限定性","本期金额")) + Number(data.本月非限定性);
        let b = Number(seachData("资产变动额限定性","本期金额")) + Number(data.本月限定性);
        let c = Number(seachData("资产变动额非限定性","本年累计")) + Number(data.本年非限定性);
        let d = Number(seachData("资产变动额限定性","本年累计")) + Number(data.本年限定性);
        let f = {"change1":a,"change2":b,"change3":c,"change4":d}
        changeData.value = f;
        console.log(changeData.value)
      }).finally(() => loading.value = false);
    }).finally(() => loading.value = false);
  }  
}
loadData()
watch(voucherDate, () => {
  loadData();
})


const exportData = () => {
  const clone = jQuery(reportContent.value).clone();
  clone.find('.report-edit-formulas').remove()
  let dataList = [];
  clone.find("tr").each((idx, tr) => {
    let row = [];
    jQuery(tr).find('td').each((idx, td) => {
      let val = jQuery(td).data('val');
      let lv = jQuery(td).data('lv') || 0;
      if (!val || val === '-0') {
        val = jQuery(td).text();
      }
      for (let i = 0; i < lv; i++) {
        val = "    " + val
      }
      row.push(val)
    })
    dataList.push(row);
  })
  console.log(dataList)
  dloading.value = true;
  Report.download({
    title: '业务活动表' + (dimension.value === 'QUARTER' ? '季报' : ''),
    voucherDate: voucherDate.value,
    accountSetsName: `编制单位：${accountSetsName.value}`,
    dataList
  }).then((data) => {
    downloadBlob(manba().format("YYYYMMDDhhmmss") + "业务活动表" + (dimension.value === 'QUARTER' ? '季报' : '') + ".xls", data)
  }).finally(() => dloading.value = false)
}
</script>

<style lang="less" scoped>
/* 针对业务活动表的表头固定样式 xf */
.cus-table thead {
  position: -webkit-sticky; /* Safari 兼容 */
  position: sticky;
  top: -10px; /* 固定在顶部，如果有其他固定导航栏，可以改为具体像素值，如 top: 60px */  
  z-index: 10; /* 确保层级高于 tbody */
  background-color: #f5f7fa; /* 必须设置背景色，否则滚动时内容会透视过来 */
  /* 如果默认背景透明，请强制覆盖 */
}
</style>